import { createContext, useContext, useState } from "react";

const WorkStatusContext = createContext();

export const WorkStatusProvider = ({ children }) => {
  const [workStatus, setWorkStatus] = useState(null);
  const [statusStartedAt, setStatusStartedAt] = useState(null);
  const [taskStarted, setTaskStarted] = useState(false);

  const onStatusChanged = (status) => {
    setWorkStatus(status);
    setStatusStartedAt(new Date().toISOString());
  };

  return (
    <WorkStatusContext.Provider
      value={{
        workStatus,
        statusStartedAt,
        taskStarted,
        setTaskStarted,
        setWorkStatus,
        setStatusStartedAt,
        onStatusChanged,

      }}
    >
      {children}
    </WorkStatusContext.Provider>
  );
};

export const useWorkStatus = () => useContext(WorkStatusContext);